<template>
  <div class='input'>
    <template v-if='label'>
      <div class='mb-8 text-sm text-gray-500'>
        <div class='truncate'>{{ label }}</div>
      </div>
    </template>
    <input class='inp'
      :type='type'
      :placeholder='placeholder'
      :readonly='readonly'
      :disabled='disabled'
      :value='modelValue'
      @input='$emit("update:modelValue", $event.target.value)'>
  </div>
</template>

<script>
  export default {
    props: {
      type: String,
      label: String,
      placeholder: String,
      readonly: Boolean,
      disabled: Boolean,
      modelValue: [String, Number]
    },

    emits: ['update:modelValue']
  }
</script>

<style lang='scss' scoped>
  .inp {
    padding: 0 12px;
    border: 1px solid theme('colors.gray.300');
    width: 100%;
    height: 40px;
    border-radius: 4px;

    &:focus,
    &:hover {
      border-color: theme('colors.primary.500');
    }

    &:disabled {
      border-color: theme('colors.gray.300');
      color: theme('colors.gray.500');
    }

    &::placeholder {
      color: theme('colors.gray.500');
    }
  }
</style>
